import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  grid-column: 1 / span 2;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  grid-gap: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 224px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled from 'styled-components';
import SearchOutlined from '@ant-design/icons/SearchOutlined';
import Button from '../button';
import Columns from '../columns';
import Input from '../input';
export var BasicFilterDropdown = function BasicFilterDropdown(_ref) {
  var setSelectedKeys = _ref.setSelectedKeys,
      selectedKeys = _ref.selectedKeys,
      confirm = _ref.confirm,
      clearFilters = _ref.clearFilters;
  return /*#__PURE__*/React.createElement(DropWrap, null, /*#__PURE__*/React.createElement(DropDown, {
    gridTemplateColumns: "1fr 1fr"
  }, /*#__PURE__*/React.createElement(InputArea, {
    placeholder: "Search",
    value: selectedKeys[0],
    onChange: function onChange(e) {
      return setSelectedKeys(e.target.value ? [e.target.value] : []);
    },
    onPressEnter: confirm
  }), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: confirm,
    icon: /*#__PURE__*/React.createElement(SearchOutlined, null)
  }, "Search"), /*#__PURE__*/React.createElement(Button, {
    onClick: clearFilters
  }, "Reset")));
};
var SearchIcon = styled(SearchOutlined)(_templateObject(), function (_ref2) {
  var theme = _ref2.theme,
      filtered = _ref2.filtered;
  return filtered ? theme.palette.primary.main : null;
});
var DropWrap = styled.div(_templateObject2());
var DropDown = styled(Columns)(_templateObject3(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing.sm;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing.sm;
});
var InputArea = styled(Input)(_templateObject4());
export var FilterIcon = function FilterIcon(filtered) {
  return /*#__PURE__*/React.createElement(SearchIcon, {
    filtered: filtered
  });
};